<template>
  <div class="row">
    <label class="label">
      Ürün Görselleri
    </label>
    <div class="image-container">
      <ul>
        <li class="import">
          <div @click="showImagePicker = true">
            <img :src="`${$root.cdnUrl}assets/icon-add-circle-orange.svg`">
            <span>Yeni Görsel Yükle</span>
          </div>
        </li>
        <li
          v-for="(image, k) in getImages"
          :key="k"
        >
          <div>
            <img :src="image">
            <span
              class="icon-close"
              @click="onRemove(k)"
            >
              <img :src="`${$root.cdnUrl}assets/icon-close-gray.svg`">
            </span>
          </div>
        </li>
      </ul>
    </div>

    <ModalImage
      :show="showImagePicker"
      @close="closeImagePicker"
      @onMediaCenter="onMediaCenter"
      @onSelect="selectedImages"
    />

    <ModalMediaGallery
      :show="showMediaGallery"
      @close="closeMediaGallery"
      @onSelect="selectedImages"
    />
  </div>
</template>

<script>
import imageFormat from '@/utils/images';
import ModalMediaGallery from '@/components/Modals/ModalMediaGallery';
import ModalImage from '../Modals/ModalImage';
import Sortable from 'sortablejs';

export default {
  name: 'ProductImage',
  components: { ModalImage, ModalMediaGallery },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  directives: {
    sortable: {
      bind: (el, binding, vnode) => {
        const vm = vnode.context;
        const key = binding.arg;
        const options = { ...binding.value };

        options.onUpdate = function (e) {
          const array = vm[key];
          const target = array[e.oldIndex];
          vm.updateOrder({
            target,
            oldIndex: e.oldIndex,
            newIndex: e.newIndex,
          });
        };

        Sortable.create(el, options || {});
      },
    },
  },
  data () {
    return {
      showMediaGallery: false,
      showImagePicker: false,
    };
  },
  computed: {
    getImages () {
      return this.images.map(image => imageFormat.getCdnImage(image.url, 'icon'));
    },
  },
  methods: {
    updateOrder (e) {
      this.images.splice(e.newIndex, 0, this.images.splice(e.oldIndex, 1)[0]);
      this.$emit('updateOrder', this.images);
    },
    onMediaCenter () {
      this.showMediaGallery = true;
      this.closeImagePicker();
    },
    closeImagePicker () {
      this.showImagePicker = false;
    },
    closeMediaGallery () {
      this.showMediaGallery = false;
    },
    selectedImages (images) {
      this.$emit('selectedImages', images);
    },
    onRemove (k) {
      this.images.splice(k, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
  .image-container {
    border: 1px solid #D5D9E1;
    border-radius: 4px;
    width: 100%;
    overflow: hidden;
    overflow-x: auto;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      li {
        padding: 10px 0;
        &:first-child{
          padding-left: 10px;
        }
        &:last-child{
          padding-right: 10px;
        }
        div {
          min-width: 100px;
          max-width: 100px;
          max-height: 150px;
          overflow: hidden;
          border: 1px solid #D8D8D8;
          border-radius: 4px;

          position: relative;
          .icon-close{
            position: absolute;
            top: 5px;
            right: 5px;
            background-color: #ffffff;
            border-radius: 50%;
            display: block;
            width: 20px;
            height: 20px;
            padding: 5px;
          }
        }
        img {
          width: 100%;
          display: block;
        }
        & + li {
          margin-left: 5px;
        }
        &.import {
          font-weight: 500;
          color: #f27a1a;
          font-size: 12px;
          div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 150px;
          }
          img {
            display: block;
            width: 20px;
            margin-bottom: 5px;
          }
          span {
            display: block;
            text-align: center;
          }
        }
      }
    }
  }
</style>
